<template>
  <div class="filters-search">
    <div class="input-search-wrapper row mb-4">
      <div class="col-lg-8 col-xl-6 col-xxl-5">
        <div class="mb-4">
          <label
            for="search-input"
            class="form-label visually-hidden"
            v-html="$store.state.i18n.search"
          ></label>

          <input
            type="text"
            class="form-control"
            id="search-input"
            :placeholder="$store.state.i18n.search"
            v-model="$store.state.searchInput"
            @input="debounceSearch"
          />
        </div>

        <Compteur />
      </div>
    </div>

    <div class="row align-items-center mb-4">
      <div class="col-xl-2 mb-3">
        <span
          class="text-primary me-5 mb-3 mb-3"
          v-html="$store.state.i18n.filter_by"
        ></span>
      </div>

      <div class="col-xl-10">
        <div class="row align-items-center">
          <div class="multiselect-wrapper mb-3 col-lg">
            <multiselect
              v-model="selectedContent"
              :options="$store.state.post_types_for_filter"
              :multiple="true"
              label="label"
              track-by="name"
              :close-on-select="true"
              :placeholder="$store.state.i18n.content_type"
              :searchable="false"
              @input="selectContent"
            >
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="pseudo-checkbox"></span
                  ><span
                    class="option__title"
                    v-html="props.option.label"
                  ></span>
                </div>
              </template>
            </multiselect>
          </div>

          <div
            class="multiselect-wrapper mb-3 col-lg"
            v-for="(taxonomy, index) in $store.state.taxonomies"
            :key="'taxonomy_' + index"
          >
            <multiselect
              v-model="taxonomy.model"
              :options="taxonomy.terms"
              :multiple="true"
              label="name"
              track-by="term_id"
              :close-on-select="true"
              :placeholder="taxonomy.label"
              :searchable="false"
              @select="addTaxonomy"
              @remove="removeTaxonomy"
            >
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="pseudo-checkbox"></span
                  ><span
                    class="option__title"
                    v-html="props.option.name"
                  ></span>
                </div>
              </template>

              <template v-slot:tag="{ option, remove }">
                <span class="multiselect__tag" :key="option.term_id">
                  <span v-html="option.name"></span>
                  <i
                    aria-hidden="true"
                    tabindex="1"
                    @keypress.enter.prevent="remove(option)"
                    @mousedown.prevent="remove(option)"
                    class="multiselect__tag-icon"
                  ></i>
                </span>
              </template>
            </multiselect>
          </div>

          <!--<div class="multiselect-wrapper mb-3 col-lg-3">
            <multiselect
              v-model="selectedPlayground"
              :options="$store.state.playground_tax_list"
              :multiple="true"
              label="name"
              track-by="term_id"
              :close-on-select="true"
              :placeholder="$store.state.i18n.playground_tax_title"
              :searchable="false"
              @select="addTaxonomy"
              @remove="removeTaxonomy"
            >
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="pseudo-checkbox"></span
                  ><span
                    class="option__title"
                    v-html="props.option.name"
                  ></span>
                </div>
              </template>

              <template v-slot:tag="{ option, remove }">
                <span class="multiselect__tag" :key="option.term_id">
                  <span v-html="option.name"></span>
                  <i
                    aria-hidden="true"
                    tabindex="1"
                    @keypress.enter.prevent="remove(option)"
                    @mousedown.prevent="remove(option)"
                    class="multiselect__tag-icon"
                  ></i>
                </span>
              </template>
            </multiselect>
          </div>

          <div class="multiselect-wrapper mb-3 col-lg-3">
            <multiselect
              v-model="selectedPartner"
              :options="$store.state.partner_tax_list"
              :multiple="true"
              label="name"
              track-by="term_id"
              :close-on-select="true"
              :placeholder="$store.state.i18n.partner_tax_title"
              :searchable="false"
              @select="addTaxonomy"
              @remove="removeTaxonomy"
            >
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="pseudo-checkbox"></span
                  ><span
                    class="option__title"
                    v-html="props.option.name"
                  ></span>
                </div>
              </template>

              <template v-slot:tag="{ option, remove }">
                <span class="multiselect__tag" :key="option.term_id">
                  <span v-html="option.name"></span>
                  <i
                    aria-hidden="true"
                    tabindex="1"
                    @keypress.enter.prevent="remove(option)"
                    @mousedown.prevent="remove(option)"
                    class="multiselect__tag-icon"
                  ></i>
                </span>
              </template>
            </multiselect>
          </div>

          <div class="multiselect-wrapper mb-3 col-lg-3">
            <multiselect
              v-model="selectedExpertise"
              :options="$store.state.expertise_tax_list"
              :multiple="true"
              label="name"
              track-by="term_id"
              :close-on-select="true"
              :placeholder="$store.state.i18n.expertise_tax_title"
              :searchable="false"
              @select="addTaxonomy"
              @remove="removeTaxonomy"
            >
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="pseudo-checkbox"></span
                  ><span
                    class="option__title"
                    v-html="props.option.name"
                  ></span>
                </div>
              </template>

              <template v-slot:tag="{ option, remove }">
                <span class="multiselect__tag" :key="option.term_id">
                  <span v-html="option.name"></span>
                  <i
                    aria-hidden="true"
                    tabindex="1"
                    @keypress.enter.prevent="remove(option)"
                    @mousedown.prevent="remove(option)"
                    class="multiselect__tag-icon"
                  ></i>
                </span>
              </template>
            </multiselect>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Compteur from "./parts/Compteur";
import Multiselect from "vue-multiselect";

export default {
  name: "FiltersSearch",
  components: {
    Compteur,
    Multiselect,
  },

  data() {
    return {
      inputSearch: "",
      selectedContent: null,
    };
  },

  methods: {
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.$store.commit("UPDATE_SEARCH", event.target.value);
        this.$store.dispatch("newRequest");
      }, 1000);
    },

    selectContent(value, id) {
      this.$store.commit("REMOVE_ALL_POSTTYPES");

      let that = this;

      value.forEach(function (item) {
        that.$store.commit("ADD_POSTTYPE", [item.label, item.name]);
      });

      this.$store.dispatch("newRequest");
    },

    addTaxonomy(selectedOption, id) {
      let tax_key = false;

      this.$store.state.taxonomies.forEach(function (tax, index) {
        if (tax.taxonomy == selectedOption.taxonomy) {
          tax_key = index;
        }
      });

      this.$store.commit("ADD_TAXONOMY", [tax_key, selectedOption.term_id]);

      let post_key = selectedOption.taxonomy.split("_")[0];

      this.$store.commit("SET_ADDITIONNAL_PAGE", {
        type: post_key,
        include: selectedOption.description,
      });

      this.$store.dispatch("newRequest");
    },

    removeTaxonomy(selectedOption, id) {
      this.$store.commit("SET_ADDITIONNAL_PAGE", false);

      let tax_key = false;

      this.$store.state.taxonomies.forEach(function (tax, index) {
        if (tax.taxonomy == selectedOption.taxonomy) {
          tax_key = index;
        }
      });

      this.$store.commit("REMOVE_TAXONOMY", [tax_key, selectedOption.term_id]);
      this.$store.dispatch("newRequest");
    },
  },
};
</script>
